import { useLocalSearchParams } from 'expo-router'

import { AuthCompleteScreen } from '@/src/features/auth/ui/screens/AuthCompleteScreen'

export default () => {
  const searchParams = useLocalSearchParams()
  return <AuthCompleteScreen searchParams={searchParams} />
}
